import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  min-width: 0;
`;

export const DisplayButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: text;
  min-width: 0;
  text-align: left;
`;

export const DisplayText = styled.span`
  color: ${(props) => props.$isPlaceholder
    ? props.theme.colors.davysGrey
    : props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: ${(props) => (props.$variant === 'title' ? '20px' : '14px')};
  font-weight: ${(props) => (props.$variant === 'title' ? 600 : 500)};
  line-height: ${(props) => (props.$variant === 'title' ? '24px' : '20px')};
  white-space: ${(props) => (props.$variant === 'title' ? 'nowrap' : 'normal')};
`;

export const Input = styled.input`
  border: 1px solid ${(props) => props.theme.colors.activeBlue};
  border-radius: 6px;
  outline: none;
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: ${(props) => (props.$variant === 'title' ? '20px' : '14px')};
  font-weight: ${(props) => (props.$variant === 'title' ? 600 : 500)};
  line-height: ${(props) => (props.$variant === 'title' ? '24px' : '20px')};
  min-width: ${(props) => (props.$variant === 'title' ? '220px' : '320px')};
  padding: 0 6px;
  height: ${(props) => (props.$variant === 'title' ? '28px' : '24px')};
`;
